function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "help-mid_svg__a",
  "data-name": "Help_ic_mid",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.88 70.29S78.61 55.68 96 55.76s23.27 21.42 14.1 30.75c-4.1 4.19-7.61 7.64-10.1 10.06a13.39 13.39 0 00-4 9.57v7.73",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 136,
  r: 2,
  fill: "none",
  stroke: "#e60000",
  strokeMiterlimit: 10,
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96,
  r: 78,
  fill: "none",
  stroke: "#6e6a69",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Help_ic_mid",
  width: 192,
  height: 192,
  xlinkHref: "#help-mid_svg__a"
}));

var SvgHelpMid = function SvgHelpMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgHelpMid;